// React
import React from "react";
import PropTypes from "prop-types";
// Styles
import styles from "./NoInformation.css";

const NoInformation = ({ label }) => (
  <div className="col col-xs-12">
    <div style={styles.container}>{label}</div>
  </div>
);

NoInformation.defaultProps = {
  label: ""
};

NoInformation.propTypes = {
  label: PropTypes.string
};

export default NoInformation;
